import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import type { ChangelogEntry } from '../../models/changelog/changelog.model';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class ChangelogService {
  private destination = '/changelog'; // Adjust this URL to match your API endpoint

  constructor(private http: HttpClient) {}

  getChangelogEntries(): Observable<ChangelogEntry[]> {
    return this.http.get<ChangelogEntry[]>(environment.apiUrl + this.destination);
  }

  getChangelogEntry(id: string): Observable<ChangelogEntry> {
    return this.http.get<ChangelogEntry>(`${environment.apiUrl +this.destination}/${id}`);
  }

  createChangelogEntry(entry: Omit<ChangelogEntry, 'id'>): Observable<ChangelogEntry> {
    return this.http.post<ChangelogEntry>(environment.apiUrl + this.destination, entry);
  }

  updateChangelogEntry(id: string, entry: Partial<ChangelogEntry>): Observable<ChangelogEntry> {
    return this.http.put<ChangelogEntry>(`${environment.apiUrl + this.destination}/${id}`, entry);
  }

  deleteChangelogEntry(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl + this.destination}/${id}`);
  }
}